import { CompilationTheme } from "@memento/types/compilation-theme";

export function getCompositionHasFaceCollage(
  theme?: CompilationTheme | undefined | null
) {
  return theme?.scenes.some(
    (scene) => "faceCollage" in scene && scene.faceCollage !== undefined
  );
}
